<template>
  <section class="relative w-full main-page py-40 min-h-screen">
    <div class="absolute top-0 w-full h-full bg-no-repeat bg-full"></div>
    <div class="container mx-auto px-4 h-full">
      <div class="flex content-center items-center justify-center h-full">
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
            <div class="rounded-t mb-0 px-6 py-6"></div>
            <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
              <div class="text-blueGray-400 text-center mb-3 font-bold">
                <div style="font-size: 18px">
                  Регистрация аккаунта
                </div>
              </div>
              <form @submit.prevent="registerUser" class="client-form">
                <div class="flex-center">

                  <div class="inl-45 relative w-full mb-3">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Логин
                    </label>
                    <input
                      type="text"
                      v-model="formData.login"
                      @change="validateField('login')"
                      :class="['border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150', fieldErrors.login && 'border-2 border-red-500 bg-red-50']"
                      placeholder="Введите логин"
                    />
                    <small v-if="fieldErrors.login" class="text-red-500">{{ fieldErrors.login }}</small>
                  </div>

                  <div class="inl-45 relative w-full mb-3">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      ФИО
                    </label>
                    <input
                      type="text"
                      v-model="formData.fio"
                      @change="validateField('fio')"
                      :class="['border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150', fieldErrors.fio && 'border-2 border-red-500 bg-red-50']"
                      placeholder="Введите ФИО"
                    />
                    <small v-if="fieldErrors.fio" class="text-red-500">{{ fieldErrors.fio }}</small>
                  </div>

                  <div class="inl-45 relative w-full mb-3">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Email (опционально)
                    </label>
                    <input
                      type="email"
                      v-model="formData.email"
                      class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Введите email"
                    />
                  </div>

                  <div class="inl-45 relative w-full mb-3">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Телефон
                    </label>
                    <input
                      type="tel"
                      v-model="formData.phone"
                      @change="validateField('phone')"
                      :class="['border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150', fieldErrors.phone && 'border-2 border-red-500 bg-red-50']"
                      placeholder="+7xxxxxxxxxx"
                    />
                    <small :class="fieldErrors.phone ? 'text-red-500' : 'text-gray-500'">{{ fieldErrors.phone || 'Формат: +7xxxxxxxxxx' }}</small>
                  </div>

                  <div class="inl-45 relative w-full mb-3">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Роль
                    </label>
                    <select
                      v-model="formData.role"
                      @change="validateField('role')"
                      :class="['border-0 px-3 py-3 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150', fieldErrors.role && 'border-2 border-red-500 bg-red-50']"
                    >
                      <option :value="1">Ученик</option>
                      <option :value="2">Эксперт</option>
                      <option :value="4">Представитель компании</option>
                    </select>
                    <small v-if="fieldErrors.role" class="text-red-500">{{ fieldErrors.role }}</small>
                  </div>

                  <div class="inl-45 relative w-full mb-3">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Пароль
                    </label>
                    <div class="relative">
                      <input
                        :type="showPassword ? 'text' : 'password'"
                        v-model="formData.password"
                        @change="validateField('password')"
                        :class="['border-0 px-3 py-3 pr-10 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150', fieldErrors.password && 'border-2 border-red-500 bg-red-50']"
                        placeholder="Введите пароль"
                        autocomplete="new-password"
                      />
                      <PasswordVisibilityToggle
                        :visible="showPassword"
                        @toggle="showPassword = !showPassword"
                      />
                    </div>
                    <small v-if="fieldErrors.password" class="text-red-500">{{ fieldErrors.password }}</small>
                    <small v-else class="text-gray-500">Минимум 8 символов, заглавные/строчные буквы, цифры и спецсимволы</small>
                  </div>

                  <div class="inl-45 relative w-full mb-3">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                      Повторите пароль
                    </label>
                    <div class="relative">
                      <input
                        :type="showPassword2 ? 'text' : 'password'"
                        v-model="formData.password2"
                        @change="validateField('password2')"
                        :class="['border-0 px-3 py-3 pr-10 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150', fieldErrors.password2 && 'border-2 border-red-500 bg-red-50']"
                        placeholder="Повторите пароль"
                        autocomplete="new-password"
                      />
                      <PasswordVisibilityToggle
                        :visible="showPassword2"
                        show-label="Показать повтор пароля"
                        hide-label="Скрыть повтор пароля"
                        @toggle="showPassword2 = !showPassword2"
                      />
                    </div>
                    <small v-if="fieldErrors.password2" class="text-red-500">{{ fieldErrors.password2 }}</small>
                  </div>

                </div>
                <div class="text-center mt-6">
                  <button
                    class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                    type="submit"
                  >
                    Зарегистрироваться
                  </button>
                </div>
              </form>
              <p class="text-xs text-blueGray-400 mt-4 text-center">
                Возникли проблемы с регистрацией? <router-link to="/client/feedback?from=/client/register" class="underline text-blue-600">Обратитесь к модератору</router-link>
              </p>
            </div>
          </div>
          <div class="flex flex-wrap mt-6 relative">
            <div class="w-1/2"></div>
            <div class="w-1/2 text-right"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { API_CLIENT, HEADERS_JSON } from "@/const/uri";
import { mapActions, mapMutations } from "vuex";
import PasswordVisibilityToggle from "@/components/Forms/PasswordVisibilityToggle.vue";

export default {
  components: {
    PasswordVisibilityToggle,
  },
  data() {
    return {
      formData: {
        login: '',
        fio: '',
        role: 1,
        email: '',
        phone: '',
        password: '',
        password2: '',
      },
      fieldErrors: {},
      showPassword: false,
      showPassword2: false,
      requiredFields: ['login', 'fio', 'phone', 'password', 'password2']
    };
  },
  methods: {
    ...mapActions(['toggleAlert']),
    ...mapMutations(['modalShow']),

    validateField(fieldName) {
      const value = this.formData[fieldName];
      let error = '';

      // Проверка на пустоту для обязательных полей
      if (this.requiredFields.includes(fieldName)) {
        if (!value || (typeof value === 'string' && value.trim() === '')) {
          const fieldLabels = {
            login: 'Логин',
            fio: 'ФИО',
            phone: 'Телефон',
            password: 'Пароль',
            password2: 'Повторение пароля'
          };
          error = `${fieldLabels[fieldName]} - обязательное поле`;
          this.fieldErrors[fieldName] = error;
          return;
        }
      }

      // Проверка формата телефона
      if (fieldName === 'phone' && value) {
        const phoneRegex = /^\+7\d{10}$/;
        if (!phoneRegex.test(value)) {
          error = 'Неверный формат. Используйте: +7xxxxxxxxxx';
          this.fieldErrors[fieldName] = error;
          return;
        }
      }

      // Проверка требований пароля
      if (fieldName === 'password' && value) {
        const hasMinLength = value.length >= 8;
        const hasUppercase = /[A-Z]/.test(value);
        const hasLowercase = /[a-z]/.test(value);
        const hasDigit = /\d/.test(value);
        const hasSpecialChar = /[^\w\s]/.test(value);

        const errors = [];
        if (!hasMinLength) errors.push('минимум 8 символов');
        if (!hasUppercase) errors.push('заглавные буквы');
        if (!hasLowercase) errors.push('строчные буквы');
        if (!hasDigit) errors.push('цифры');
        if (!hasSpecialChar) errors.push('спецсимволы');

        if (errors.length > 0) {
          error = `Нужны: ${errors.join(', ')}`;
          this.fieldErrors[fieldName] = error;
          return;
        }
      }

      // Проверка совпадения паролей
      if (fieldName === 'password2' && value) {
        if (value !== this.formData.password) {
          error = 'Пароли не совпадают';
          this.fieldErrors[fieldName] = error;
          return;
        }
      }

      // Если ошибок нет, удаляем ошибку
      delete this.fieldErrors[fieldName];
    },

    validateAllFields() {
      const emptyFields = [];
      for (const field of this.requiredFields) {
        this.validateField(field);
        if (this.fieldErrors[field]) {
          emptyFields.push(field);
        }
      }
      return emptyFields.length === 0;
    },

    async registerUser() {
      try {
        // Валидируем все поля
        if (!this.validateAllFields()) {
          const errorMessages = Object.values(this.fieldErrors).filter(err => err);
          const messages = errorMessages.map((msg, idx) => ({
            title: `Ошибка ${idx + 1}`,
            message: msg
          }));
          this.modalShow({
            messages,
            title: 'Ошибки в форме',
            isError: true,
          });
          return;
        }

        const { data } = await axios.post(API_CLIENT.register, this.formData, {
          headers: HEADERS_JSON,
        });
        this.modalShow({
          messages: [{
            'title': data.message,
            'message': 'Регистрация прошла успешна, ожидайте подтверждения модератором. Модератор рассмотрит вашу заявку в течение 3 рабочих дней. После подтверждения вы сможете войти в систему. Если потребуется ускорить процесс, воспользуйтесь формой обратной связи (/client/feedback).',
          }],
          title: 'Регистрация',
          isError: false,
          callback: () => {
            this.$router.push({ name: 'ClientLogin' });
          },
        });
      } catch (e) {
        const errorData = e.response?.data;
        if (errorData && typeof errorData === 'object') {
          if (errorData.detail) {
            this.toggleAlert({
              message: errorData.detail,
              isError: true,
            });
          } else if (errorData.errors) {
            // Handle field-specific errors from server (nested structure)
            const messages = [];
            for (const [field, fieldMessages] of Object.entries(errorData.errors)) {
              const errorText = Array.isArray(fieldMessages) ? fieldMessages[0] : fieldMessages;
              this.fieldErrors[field] = errorText;
              messages.push({
                title: `Ошибка в поле "${field}"`,
                message: errorText
              });
            }
            this.modalShow({
              messages,
              title: 'Ошибки регистрации',
              isError: true,
            });
          } else {
            // Handle other field-specific errors
            const messages = [];
            for (const [field, message] of Object.entries(errorData)) {
              this.fieldErrors[field] = Array.isArray(message) ? message.join(', ') : message;
              const errorText = Array.isArray(message) ? message[0] : message;
              messages.push({
                title: `Ошибка в поле "${field}"`,
                message: errorText
              });
            }
            this.modalShow({
              messages,
              title: 'Ошибки регистрации',
              isError: true,
            });
          }
        } else {
          this.toggleAlert({
            message: 'Ошибка регистрации. Проверьте данные и попробуйте снова.',
            isError: true,
          });
        }
      }
    }
  }
};
</script>
